export function formatFilesize(bytes: number): string {
	const units = ['B', 'kB', 'MB', 'GB', 'TB']
	let unitIndex = 0

	while (bytes >= 1000 && unitIndex < units.length - 1) {
		bytes /= 1024
		unitIndex++
	}

	return `${bytes.toPrecision(3)} ${units[unitIndex]}`
}
